import { subscriptionsStore } from './model';
import { SET_SUBSCRIPTIONS_PLANS, SET_CURRENCY } from './constants';

export function subscriptionsReducer(state = subscriptionsStore, action) {
    switch (action.type) {
        case SET_SUBSCRIPTIONS_PLANS:
            let allSubscriptionsPlans = action.payload.map(sub => {
                return {
                    id: sub.plan.id,
                    name: sub.plan.name,
                    period: sub.plan.period,
                    price: sub.product.price,
                };
            });
            allSubscriptionsPlans.unshift({
                id: 'FREE_PLAN',
                name: 'PAUSED MEMBERSHIP',
                drivingPricePerMinute: window.VULOG_CONFIG.FREE_PLAN_DRIVING_PRICE,
                price: 0,
                stopOverPricePerMinute: window.VULOG_CONFIG.FREE_PLAN_STOP_OVER_PRICE,
            });
            return {
                ...state,
                allSubscriptionsPlans,
            };

        case SET_CURRENCY:
            return {
                ...state,
                currency: action.payload,
            };

        default:
            return state;
    }
}
